import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared/shared.module';
import { CheckoutCartComponent } from './subscription-checkout/checkout-cart/checkout-cart.component';
import { CheckoutConfirmationComponent } from './subscription-checkout/checkout-confirmation/checkout-confirmation.component';
import { CheckoutPaymentComponent } from './subscription-checkout/checkout-payment/checkout-payment.component';
import { CheckoutPurchaserInfoComponent } from './subscription-checkout/checkout-purchaser-info/checkout-purchaser-info.component';
import { SubscriptionCheckoutComponent } from './subscription-checkout/subscription-checkout.component';
import { SubscriptionMenuItemSelectedComponent } from './subscription-menu/subscription-menu-menu-items/subscription-menu-item-selected/subscription-menu-item-selected.component';
import { SubscriptionMenuItemComponent } from './subscription-menu/subscription-menu-menu-items/subscription-menu-item/subscription-menu-item.component';
import { SubscriptionMenuMenuItemsComponent } from './subscription-menu/subscription-menu-menu-items/subscription-menu-menu-items.component';
import { SubscriptionMenuComponent } from './subscription-menu/subscription-menu.component';
import { SubscriptionRoutingModule } from './subscription-routing.module';
import { SubscriptionComponent } from './subscription.component';
import { CheckoutShippingInformationComponent } from './subscription-checkout/checkout-shipping-information/checkout-shipping-information.component';

@NgModule({
	declarations: [
		SubscriptionComponent,
		SubscriptionMenuComponent,
		SubscriptionMenuMenuItemsComponent,
		SubscriptionMenuItemComponent,
		SubscriptionMenuItemSelectedComponent,
		SubscriptionCheckoutComponent,
		CheckoutPurchaserInfoComponent,
		CheckoutPaymentComponent,
		CheckoutConfirmationComponent,
		CheckoutCartComponent,
  CheckoutShippingInformationComponent,
	],
	imports: [SharedModule, SubscriptionRoutingModule],
})
export class SubscriptionModule {}
